import React, { forwardRef } from 'react';
import { Checkbox as CheckboxBase, CheckboxProps } from '@mui/material';
import { ReactComponent as CheckboxCheckedIcon } from '../../assets/checkbox-checked.svg';
import { ReactComponent as CheckboxDashedIcon } from '../../assets/checkbox-dash.svg';
import { ReactComponent as CheckboxIcon } from '../../assets/checkbox.svg';
import { componentToken } from '../../style/utils';

type Props = CheckboxProps & {
  $noPadding?: boolean;
};

const Checkbox = forwardRef(({ $noPadding, ...props }: Props, ref: any) => (
  <CheckboxBase
    ref={ref}
    {...props}
    sx={{
      '&:hover': { bgcolor: 'transparent' },
      '&.MuiButtonBase-root': {
        padding: $noPadding ? '0 !important' : undefined,
      },
      "& [class$='checkbox-box']": {
        fill: componentToken('checkbox.uncheckedBg'),
        stroke: componentToken('checkbox.border'),
      },
      "& [class$='checkbox-checked-box']": {
        fill: componentToken('checkbox.checkedBg'),
      },
      "& [class$='checkbox-check-mark']": {
        fill: componentToken('checkbox.mark'),
      },
      "& [class$='checkbox-dash-mark']": {
        stroke: componentToken('checkbox.mark'),
      },
      ...props.sx,
    }}
    icon={<CheckboxIcon />}
    checkedIcon={<CheckboxCheckedIcon />}
    indeterminateIcon={<CheckboxDashedIcon />}
  />
));

export default Checkbox;
